import { render, staticRenderFns } from "./SearchDrawerLands.vue?vue&type=template&id=64d61c60&scoped=true&"
import script from "./SearchDrawerLands.vue?vue&type=script&lang=js&"
export * from "./SearchDrawerLands.vue?vue&type=script&lang=js&"
import style0 from "./SearchDrawerLands.vue?vue&type=style&index=0&id=64d61c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d61c60",
  null
  
)

export default component.exports